<!-- 朋友圈海报 -->
<template>
  <div>
    <div class="head-title">海报设计</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>1、点击创建海报，导入图片素材进行图片编辑并保存发布</p>
          <p>
            2、海报发布成功后可下载原图至本地进行使用；也可直接上传至朋友圈素材库，作为企业发布朋友圈任务时图片素材的选择
          </p>
          <p>3、海报生成后支持再次编辑</p>
          <p>4、创建海报的时候点击预览&设置按钮可以对作品重命名</p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <nav class="navbar">
      <div class="nav-l">
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >创建海报</el-button
        >
      </div>
      <div class="nav-r"></div>
    </nav>
    <div class="main">
      <el-empty v-if="total == 0" description="暂无数据"></el-empty>
      <div class="poster_container">
        <div
          class="poster_content"
          v-for="item in list"
          :key="item.id"
          v-loading="item.loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          element-loading-text="上传中.."
        >
          <!-- <div class="poster_tag" :class="{ publish: item.status == 2 }">
            {{ item.status == 1 ? "未发布" : "已发布" }}
          </div> -->
          <img
            class="ope_img"
            :src="item.url"
            @mouseenter="item.hover = true"
          />
          <div
            class="operation_layer"
            v-if="item.hover"
            @mouseleave="item.hover = false"
          >
            <div id="permission_layer" style="width: 100%">
              <a
                class="operation"
                style="margin-bottom: 0.2rem"
                target="_blank"
                :download="item.title"
                :href="`https://api.weijub.com/crm/ActiveCode/getImages?url=${item.url}&usertoken=${tooken.usertoken}`"
              >
                <i class="anticon el-icon-download"></i>
                下载
              </a>
              <div
                class="operation"
                style="margin: 0.2rem .0rem"
                @click="onEdit(item)"
              >
                <i class="anticon el-icon-edit"></i>
                编辑
              </div>
              <!-- <div
                v-if="item.status == 1"
                class="operation"
                style="margin: 0.2rem .0rem"
                @click="onSold(item.id, 2)"
              >
                <i class="anticon el-icon-sell"></i>
                发布
              </div> -->
              <!-- <div
                v-if="item.status == 2"
                class="operation"
                style="margin: 0.2rem .0rem"
                @click="onSold(item.id, 1)"
              >
                <i class="anticon el-icon-sold-out"></i>
                下架
              </div>
              <div
                class="operation"
                style="margin: 0.2rem .0rem"
                @click="onClone(item)"
              >
                <i class="anticon el-icon-document-copy"></i>
                克隆
              </div> -->
              <div class="operation" @click="onConfirm(item)">
                <i class="anticon el-icon-delete"></i>
                删除
              </div>
              <div
                class="operation"
                style="margin: 0.2rem .0rem"
                @click="onUploadMaterial(item)"
              >
                <i class="anticon el-icon-upload2"></i>
                上传到素材库
              </div>
            </div>
          </div>
          <div
            style="font-size: 1.6rem; color: rgb(26, 26, 26); margin-top: 1.0rem"
          >
            {{ item.title }}
          </div>
          <div style="color: rgb(158, 158, 158)">{{ item.createtime }}</div>
        </div>
      </div>
      <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "friendsPoster",
  data() {
    return {
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.getList();
  },

  methods: {
    onAdd() {
      this.$router.push({
        name: "posterDesign",
      });
    },
    onEdit(row) {
      this.$router.push({
        name: "posterDesign",
        query: {
          id: row.id,
        },
      });
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
      var dataURL = canvas.toDataURL("image/" + ext);

      return dataURL;
    },
    onUploadMaterial(item) {
      item.loading = true;
      var image = new Image();
      image.src = item.url;
      image.setAttribute("crossOrigin", "Anonymous");
      image.onload = async () => {
        var base64 = this.getBase64Image(image);
        var formData = new FormData();
        //转换base64到file
        var file = this.btof(base64, "test");
        formData.append("file", file);
        formData.append("account_id", this.tooken.account_id);
        formData.append("type", "图片");
        await this.upload(formData);
        item.loading = false;
      };
    },
    btof(data, fileName) {
      const dataArr = data.split(",");
      const byteString = atob(dataArr[1]);

      const options = {
        type: "image/jpeg",
        endings: "native",
      };
      const u8Arr = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        u8Arr[i] = byteString.charCodeAt(i);
      }
      return new File([u8Arr], fileName + ".jpg", options);
    },
    async upload(data) {
      try {
        const { data: res } = await this.axios({
          url: "/crm/FriendsTask/uploadimg",
          method: "POST",
          data,
        });
        if (res.code == 1) {
          this.$message.success(res.msg);
        } else if (res.code == 0) {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 上下架
    async onSold(id, status) {
      let type = "warning";
      let title = "确定要发布吗？";
      let message = "该作品尚未发布，发布后可进行分享，是否发布？";
      if (status == 1) {
        type = "error";
        title = "确定要下架吗？";
        message = "下架后此内容无法访问";
      }

      this.$confirm(message, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type,
      })
        .then(() => {
          this.onEditStatus(id, status);
        })
        .catch(() => {});
    },
    async onEditStatus(id, status) {
      const { data: res } = await this.axios({
        url: "/crm/FriendsPoster/edit",
        method: "POST",
        data: this.qs.stringify({
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id,
          status,
        }),
      });

      if (res.code == 1) {
        const message = status == 2 ? "发布成功" : "下架成功";
        this.$message({
          type: "success",
          message,
        });
      } else if (res.code == 0) {
        const message = status == 2 ? "发布失败" : "下架失败";
        this.$message({
          type: "error",
          message,
        });
      }
      this.getList();
    },
    onClone(row) {
      this.$router.push({
        name: "posterDesign",
        query: {
          id: row.id,
          clone: true,
        },
      });
    },
    onConfirm(row) {
      this.$confirm("您确定要删除吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.onDel(String(row.id));
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async onDel(id) {
      const { data: res } = await this.axios({
        url: "/crm/FriendsPoster/del",
        method: "POST",
        data: this.qs.stringify({
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id,
        }),
      });
      this.$message({
        type: res.code ? "success" : "error",
        message: res.msg,
      });
      this.getList();
    },
    async getList() {
      const { data: res } = await this.axios({
        url: "/crm/FriendsPoster/list",
        method: "POST",
        data: this.qs.stringify({
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          title: this.title,
          start_time: this.start_time,
          end_time: this.end_time,
          page: this.listQuery.page,
          number_page:this.listQuery.limit,
        }),
      });
      console.log(res.data.total);
      if (res.code == 1) {
        const list = res.data.data.forEach((i) => {
          i.hover = false;
          i.loading = false;
        });
        this.list = res.data.data;
        this.total = res.data.total;
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>
<style lang="scss"  scoped>
.poster_container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  margin: 2.0rem 0;
}
.poster_container .poster_content {
  width: 18%;
  object-fit: cover;
  margin-top: 2.4rem;
  margin-left: 2%;
  position: relative;
  height: 39.8rem;
  min-height: 34.0rem;
}

.poster_tag {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  padding-right: 1.2rem;
  height: 2.8rem;
  color: #fefefe;
  font-size: 1.3rem;
  line-height: 2.8rem;
  text-indent: 1.7rem;
  background-color: rgb(140, 140, 140);
  border-radius: 0 0 0 5.4rem;
}
.poster_tag.publish {
  background-color: #60c22f;
}

.poster_container .poster_content .ope_img {
  padding: 1.3rem;
  width: 100%;
  object-fit: contain;
  height: 34.2rem;
  border-radius: .5rem;
  background-color: #f5f5f7;
}
.poster_container .poster_content .operation_layer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background: #000;
  opacity: 0.7;
  width: 100%;
  height: 34.2rem;
  border-radius: .4rem;
  padding: 0 2.0rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.poster_container .poster_content .operation_layer .operation {
  display: inline-block;
  width: 100%;
  color: #fff;
  cursor: pointer;
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: center;
}
.poster_container .poster_content .operation_layer .operation:hover {
  border: .2rem solid rgb(209, 209, 209);
  border-radius: .6rem;
}
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
}
.anticon svg {
  display: inline-block;
}
</style>